//   import React, { useState, useEffect } from 'react';
//   import { Helmet } from 'react-helmet';
//   import Layout from '../../components/ui/Layout';
//   import Breadcrumb from '../../components/ui/Breadcrumb';
//   import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
//   import Icon from '../../components/AppIcon';
//   import Button from '../../components/ui/Button';
//   import { useDashboardStats } from 'features/dashboard/hooks/useDashboardStats';
//   import { useBookings } from 'features/booking/hooks/useBookings';
//   import { useSellers } from 'features/seller/hooks/useSellers';
//   import { useSupportTickets } from 'features/support-ticket/hooks/useSupportTickets';
//   import { useTopSellersByBookings } from 'features/dashboard/hooks/useTopSellersByBookings';
//   import { useUserProfile } from "features/auth/hooks/useUserProfile";
//   import { useMainCategories } from 'features/main-category/hooks/useMainCategories';
// import { useCategoryWiseRevenue } from "features/dashboard/hooks/useCategoryWiseRevenue";
// import CategoryRevenueChart from "./components/CategoryRevenueChart";
//   import {
//     Eye,
//     IndianRupee,
//     Package,
//     User,
//   } from 'lucide-react';

  
//   // Import dashboard components
//   import KPICard from './components/KPICard';
//   import DateRangePicker from './components/DateRangePicker';
//   import VerticalFilter from './components/VerticalFilter';
//   import RevenueChart from './components/RevenueChart';
//   import GeographicHeatmap from './components/GeographicHeatmap';
//   import OrderFunnel from './components/OrderFunnel';
//   import AlertsFeed from './components/AlertsFeed';

//   const ITEMS_PER_PAGE = 5;

//   const ExecutiveDashboard = () => {
//     const [selectedDateRange, setSelectedDateRange] = useState('7d');
//     const [selectedVertical, setSelectedVertical] = useState('all');
//     const [isRealTimeEnabled, setIsRealTimeEnabled] = useState(true);
//     const [lastUpdated, setLastUpdated] = useState(new Date());

//     const [revenueCategoryId, setRevenueCategoryId] = useState('');

//     const [bookingPage, setBookingPage] = useState(1);
//     const [providerPage, setProviderPage] = useState(1);
//     const [ticketPage, setTicketPage] = useState(1);
//     const [topSellerPage, setTopSellerPage] = useState(1);

//     const [revenueSearch, setRevenueSearch] = useState('');
// const [revenueStartDate, setRevenueStartDate] = useState('');
// const [revenueEndDate, setRevenueEndDate] = useState('');

// const [chartStartDate, setChartStartDate] = useState('');
// const [chartEndDate, setChartEndDate] = useState('');


//     const { data: profileData } = useUserProfile();
//     const user = profileData?.data;
 
// const {
//     data: categoryRevenueResponse,
//     isPending: revenueChartLoading,
// } = useCategoryWiseRevenue({
//     startDate: chartStartDate || undefined,
//     endDate: chartEndDate || undefined,
// });

// const categoryRevenueData =
//     categoryRevenueResponse?.data || [];

    

//    const {
//   data: mainCategoriesResponse,
//   isLoading: categoriesLoading,
// } = useMainCategories({
//   page: 1,
//   limit: 100,
//   isActive: true,
//   sortBy: 'name',
//   sortOrder: 'asc',
// });

// const mainCategories =
//   (mainCategoriesResponse?.data || []).filter(
//     (category) =>
//       ![
//         'property-and-real-estate',
//         'find-jobs',
//       ].includes(category.slug)
//   );

// // console.log('Current Role:', user?.role?.name);
 
// const restrictedRoles = [
//   "delivery_manager",
//   "category_manager",
//   "operations_manager",
//   "travel_manager",
//   // "finance_manager",
// ];
 
// const showPermissionError = restrictedRoles.includes(
//   user?.role?.name
// );


//   const {
//     data: dashboardResponse,
//     isPending: dashboardLoading,
//     isError,
//     error,
//   } = useDashboardStats();

//     const dashboardStats = dashboardResponse?.data || {};

//     // Bookings API shape: { success, pagination, data: [...] }
//     // const {
//     //   data: bookingResponse,
//     //   isLoading: bookingsLoading,
//     // } = useBookings({
//     //   page: bookingPage,
//     //   limit: ITEMS_PER_PAGE,
//     //   sortBy: 'createdAt',
//     //   sortOrder: 'desc',
//     // });

//     const {
//   data: bookingResponse,
//   isLoading: bookingsLoading,
// } = useBookings({
//   page: bookingPage,
//   limit: ITEMS_PER_PAGE,
//   search: revenueSearch || undefined,
//   startDate: revenueStartDate || undefined,
//   endDate: revenueEndDate || undefined,
//   categoryId: revenueCategoryId || undefined,
//   sortBy: 'createdAt',
//   sortOrder: 'desc',
// });


    

//     // Sellers API shape: { success, data: { sellers: [...], pagination: {...} } }
//     const {
//       data: pendingProvidersResponse,
//       isPending: pendingProvidersLoading,
//     } = useSellers({
//       page: providerPage,
//       limit: ITEMS_PER_PAGE,
//       status: 'pending_approval',
//       sellerType: 'service_provider',
//       sortBy: 'createdAt',
//       sortOrder: 'desc',
//     });

//     const {
//     data: ticketsResponse,
//     isPending: ticketsLoading,
//   } = useSupportTickets({
//     page: ticketPage,
//     limit: ITEMS_PER_PAGE,
//     sortBy: 'createdAt',
//     sortOrder: 'desc',
//   });

//   const {
//     data: topSellersResponse,
//     isPending: topSellersLoading,
//   } = useTopSellersByBookings({
//     page: topSellerPage,
//     limit: ITEMS_PER_PAGE,
//   });

//     const recentBookings = bookingResponse?.data || [];
//     const bookingsPagination = bookingResponse?.pagination;

//     const pendingProviders = pendingProvidersResponse?.data?.sellers || [];
//     const providersPagination = pendingProvidersResponse?.data?.pagination;

//     const recentTickets = ticketsResponse?.data || [];
//   const ticketsPagination = ticketsResponse?.pagination;

//   const topSellers = topSellersResponse?.data || [];
//   const topSellersPagination = topSellersResponse?.pagination;

//     const kpiData = [
//       {
//         title: 'Total Customers',
//         value: dashboardStats.totalCustomers || 0,
//         icon: 'Users',
//         change: '',
//         trend: [0.2, 0.4, 0.3, 0.5, 0.6],
//       },
//       {
//         title: 'Active Providers',
//         value: dashboardStats.activeProviders || 0,
//         icon: 'Users',
//         change: '',
//         trend: [0.1, 0.3, 0.5, 0.4, 0.7],
//       },
//       {
//         title: 'Pending Provider Approvals',
//         value: dashboardStats.pendingApprovalProviders || 0,
//         icon: 'Clock',
//         change: '',
//         trend: [0.4, 0.3, 0.5, 0.2, 0.1],
//       },
//       {
//         title: 'Online Providers',
//         value: dashboardStats.onlineProvidersCount || 0,
//         icon: 'Activity',
//         change: '',
//         trend: [0.3, 0.5, 0.7, 0.6, 0.8],
//       },
//       {
//         title: 'Complaints',
//         value: dashboardStats.complaintsCount || 0,
//         icon: 'AlertTriangle',
//         change: '',
//         trend: [0.5, 0.4, 0.6, 0.3, 0.2],
//       },
//       {
//         title: 'Revenue',
//         value: `₹${(dashboardStats.totalAmount || 0).toLocaleString()}`,
//         icon: 'IndianRupee',
//         change: '',
//         trend: [0.2, 0.4, 0.6, 0.5, 0.8],
//       },
//     ];

//     const getStatusColor = (status) => {
//       const colors = {
//         pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
//         confirmed: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
//         in_progress: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
//         completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
//         cancelled: 'bg-red-500/10 text-red-600 dark:text-red-400',
//       };
//       return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
//     };

//     const getPaymentStatusColor = (status) => {
//       const colors = {
//         pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
//         processing: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
//         completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
//         failed: 'bg-red-500/10 text-red-600 dark:text-red-400',
//       };
//       return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
//     };

//     const getProviderStatusColor = (status) => {
//       const colors = {
//         pending_approval: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
//         active: 'bg-green-500/10 text-green-600 dark:text-green-400',
//         rejected: 'bg-red-500/10 text-red-600 dark:text-red-400',
//         blocked: 'bg-red-500/10 text-red-600 dark:text-red-400',
//       };
//       return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
//     };

//     const getTicketStatusColor = (status) => {
//     const colors = {
//       open: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
//       in_progress: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
//       pending_customer: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
//       pending_seller: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
//       resolved: 'bg-green-500/10 text-green-600 dark:text-green-400',
//       closed: 'bg-gray-500/10 text-gray-600 dark:text-gray-400',
//       reopened: 'bg-red-500/10 text-red-600 dark:text-red-400',
//     };

//     return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
//   };

//   const getTicketPriorityColor = (priority) => {
//     const colors = {
//       low: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
//       medium: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
//       high: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
//       urgent: 'bg-red-500/10 text-red-600 dark:text-red-400',
//     };

//     return colors[priority] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
//   };

//     // Real-time updates simulation
//     useEffect(() => {
//       if (!isRealTimeEnabled) return;
//       const interval = setInterval(() => {
//         setLastUpdated(new Date());
//       }, 15000);
//       return () => clearInterval(interval);
//     }, [isRealTimeEnabled]);

//     useEffect(() => {
//   setBookingPage(1);
// }, [revenueSearch, revenueStartDate, revenueEndDate, revenueCategoryId]);

//     const handleRefresh = async () => {
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setLastUpdated(new Date());
//     };

//     const handleExport = async () => {
//       await new Promise((resolve) => setTimeout(resolve, 2000));
//       console.log('Exporting dashboard data...');
//     };

//     const handleKPIClick = (kpi) => {
//       console.log('Drilling down into:', kpi?.title);
//     };

//     const quickActions = [
//       {
//         id: 'alerts',
//         label: 'Alerts',
//         icon: 'Bell',
//         onClick: () => console.log('View alerts'),
//         variant: 'ghost',
//         className: 'relative',
//         showLabel: false,
//       },
//       {
//         id: 'settings',
//         label: 'Settings',
//         icon: 'Settings',
//         onClick: () => console.log('Dashboard settings'),
//         variant: 'ghost',
//         showLabel: false,
//       },
//     ];

//     if (isError) {
//     return (
//       <Layout>
//         <div className="min-h-screen flex items-center justify-center">
//           <div className="text-xl font-semibold text-destructive">
//             {error?.message || 'You do not have permission to perform this action!'}
//           </div>
//         </div>
//       </Layout>
//     );
//   }

//   if (showPermissionError) {
//     return (
//       <Layout>
//         <div className="min-h-screen flex items-center justify-center">
//           <div className="text-xl font-semibold text-destructive">
//             You do not have permission to perform this action!
//           </div>
//         </div>
//       </Layout>
//     );
//   }

  
//     return (
//       <>
//         <Helmet>
//           <title>Executive Dashboard - Qkly Admin Panel</title>
//           <meta
//             name="description"
//             content="Comprehensive business intelligence dashboard providing real-time analytics and operational monitoring for marketplace administrators"
//           />
//         </Helmet>
//         <Layout>
//           <div className="px-6 py-8">
//             {/* Header Section */}
//             <div className="mb-8">
//               <Breadcrumb className="mb-4" />
//               <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//                 <div>
//                   <h1 className="text-3xl font-semibold text-foreground mb-2">
//                     Executive Dashboard
//                   </h1>
//                   <p className="text-muted-foreground">
//                     Comprehensive business intelligence and real-time
//                     performance monitoring
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* KPI Cards Grid */}
//             {dashboardLoading ? (
//               <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
//                 {[...Array(6)].map((_, index) => (
//                   <div
//                     key={index}
//                     className="h-40 rounded-lg border border-border bg-card animate-pulse"
//                   />
//                 ))}
//               </div>
//             ) : (
//               <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
//                 {kpiData?.map((kpi, index) => (
//                   <KPICard
//                     key={index}
//                     {...kpi}
//                     onClick={() => handleKPIClick(kpi)}
//                   />
//                 ))}
//               </div>
//             )}

//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">
//                     Category Wise Revenue
//                   </h2>

//                   <p className="text-sm text-muted-foreground">
//                     Platform commission grouped by category
//                   </p>
//                 </div>

//                 <div className="flex flex-wrap gap-3">
//                   <input
//                     type="date"
//                     value={chartStartDate}
//                     onChange={(e) => setChartStartDate(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm"
//                   />

//                   <input
//                     type="date"
//                     value={chartEndDate}
//                     onChange={(e) => setChartEndDate(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm"
//                   />

//                   {(chartStartDate || chartEndDate) && (
//                     <Button
//                       variant="outline"
//                       onClick={() => {
//                         setChartStartDate("");
//                         setChartEndDate("");
//                       }}
//                     >
//                       Clear
//                     </Button>
//                   )}
//                 </div>
//               </div>

//               <div className="p-6">
//                 <CategoryRevenueChart
//                   data={categoryRevenueData}
//                   loading={revenueChartLoading}
//                 />
//               </div>
//             </div>

//             {/* Revenue breakdown */}
//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">Revenue Breakdown</h2>

//                   <p className="text-sm text-muted-foreground">
//                     Seller revenues
//                   </p>
//                 </div>

//                 <div className="flex flex-wrap gap-3">
//                   <input
//                     type="text"
//                     placeholder="Search booking..."
//                     value={revenueSearch}
//                     onChange={(e) => setRevenueSearch(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm w-60"
//                   />

//                   <select
//                     value={revenueCategoryId}
//                     onChange={(e) => setRevenueCategoryId(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm min-w-[220px]"
//                   >
//                     <option value="">All Categories</option>

//                     {mainCategories.map((category) => (
//                       <option key={category._id} value={category._id}>
//                         {category.name?.english || category.name}
//                       </option>
//                     ))}
//                   </select>

//                   <input
//                     type="date"
//                     value={revenueStartDate}
//                     onChange={(e) => setRevenueStartDate(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm"
//                   />

//                   <input
//                     type="date"
//                     value={revenueEndDate}
//                     onChange={(e) => setRevenueEndDate(e.target.value)}
//                     className="border rounded-md px-3 py-2 text-sm"
//                   />

//                   {(revenueSearch || revenueStartDate || revenueEndDate) && (
//                     <Button
//                       variant="outline"
//                       onClick={() => {
//                         setRevenueSearch("");
//                         setRevenueStartDate("");
//                         setRevenueEndDate("");
//                       }}
//                     >
//                       Clear
//                     </Button>
//                   )}
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-muted border-b border-border">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Booking
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Seller
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Service/Tour
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Category
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Total Amount
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Platform Fee
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Tax
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Commission
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Payment
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Status
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Created
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody className="divide-y divide-border">
//                     {bookingsLoading ? (
//                       [...Array(5)].map((_, idx) => (
//                         <tr key={idx}>
//                           <td colSpan="7" className="px-4 py-4">
//                             <div className="h-10 bg-muted animate-pulse rounded" />
//                           </td>
//                         </tr>
//                       ))
//                     ) : recentBookings.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="7"
//                           className="px-4 py-8 text-center text-muted-foreground"
//                         >
//                           No recent bookings found
//                         </td>
//                       </tr>
//                     ) : (
//                       recentBookings.map((booking) => (
//                         <tr
//                           key={booking._id}
//                           className="hover:bg-muted/50 transition-colors"
//                         >
//                           <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
//                             #{booking.bookingNumber}
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-2">
//                               <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
//                                 <User size={14} />
//                               </div>
//                               <div className="text-sm whitespace-nowrap">
//                                 {booking.sellerId?.firstName || "--"}{" "}
//                                 {booking.sellerId?.lastName || "--"}
//                               </div>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-2">
//                               <Package size={14} />
//                               <span className="text-sm whitespace-nowrap">
//                                 {booking.serviceId?.name ||
//                                   booking?.tourId?.title ||
//                                   booking?.sellerId?.restaurantName ||
//                                   "--"}
//                               </span>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-2">
//                               <Package size={14} />
//                               <span className="text-sm whitespace-nowrap">
//                                 {booking.serviceId?.categoryId?.name?.english ||
//                                   booking.tourId?.categoryId?.name?.english ||
//                                   booking?.foodItems[0]?.categoryId?.name
//                                     ?.english ||
//                                   "--"}
//                               </span>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-1 text-sm font-medium">
//                               <IndianRupee size={14} />
//                               {booking.pricing?.totalAmount || 0}
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-1 text-sm font-medium">
//                               <IndianRupee size={14} />
//                               {booking.pricing?.platformFee || 0}
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-1 text-sm font-medium">
//                               <IndianRupee size={14} />
//                               {booking.pricing?.taxAmount || 0}
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-1 text-sm font-medium">
//                               <IndianRupee size={14} />
//                               {booking.commission?.commissionAmount || 0}
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getPaymentStatusColor(
//                                 booking.payment?.paymentStatus,
//                               )}`}
//                             >
//                               {booking.payment?.paymentStatus}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(
//                                 booking.status,
//                               )}`}
//                             >
//                               {booking.status}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
//                             {new Date(booking.createdAt).toLocaleDateString()}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* Bookings Pagination */}
//                 {bookingsPagination && (
//                   <div className="flex items-center justify-between px-4 py-3 border-t border-border">
//                     <div className="text-sm text-muted-foreground">
//                       Showing{" "}
//                       {(bookingsPagination.currentPage - 1) *
//                         bookingsPagination.itemsPerPage +
//                         1}{" "}
//                       to{" "}
//                       {Math.min(
//                         bookingsPagination.currentPage *
//                           bookingsPagination.itemsPerPage,
//                         bookingsPagination.totalItems,
//                       )}{" "}
//                       of {bookingsPagination.totalItems} bookings
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={bookingsPagination.currentPage === 1}
//                         onClick={() => setBookingPage((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>
//                       <div className="text-sm font-medium px-2">
//                         {bookingsPagination.currentPage} /{" "}
//                         {bookingsPagination.totalPages}
//                       </div>
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={
//                           bookingsPagination.currentPage ===
//                           bookingsPagination.totalPages
//                         }
//                         onClick={() => setBookingPage((prev) => prev + 1)}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Recent Bookings */}
//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">Recent Bookings</h2>
//                   <p className="text-sm text-muted-foreground">
//                     Latest booking activities
//                   </p>
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-muted border-b border-border">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Booking
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Customer
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Service
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Amount
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Payment
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Status
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Created
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody className="divide-y divide-border">
//                     {bookingsLoading ? (
//                       [...Array(5)].map((_, idx) => (
//                         <tr key={idx}>
//                           <td colSpan="7" className="px-4 py-4">
//                             <div className="h-10 bg-muted animate-pulse rounded" />
//                           </td>
//                         </tr>
//                       ))
//                     ) : recentBookings.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="7"
//                           className="px-4 py-8 text-center text-muted-foreground"
//                         >
//                           No recent bookings found
//                         </td>
//                       </tr>
//                     ) : (
//                       recentBookings.map((booking) => (
//                         <tr
//                           key={booking._id}
//                           className="hover:bg-muted/50 transition-colors"
//                         >
//                           <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
//                             #{booking.bookingNumber}
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-2">
//                               <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
//                                 <User size={14} />
//                               </div>
//                               <div className="text-sm whitespace-nowrap">
//                                 {booking.customerId?.firstName || "--"}{" "}
//                                 {booking.customerId?.lastName || "--"}
//                               </div>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-2">
//                               <Package size={14} />
//                               <span className="text-sm whitespace-nowrap">
//                                 {booking.serviceId?.name ||
//                                   booking?.tourId?.title ||
//                                   booking?.sellerId?.restaurantName ||
//                                   "--"}
//                               </span>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-1 text-sm font-medium">
//                               <IndianRupee size={14} />
//                               {booking.pricing?.totalAmount || 0}
//                             </div>
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getPaymentStatusColor(
//                                 booking.payment?.paymentStatus,
//                               )}`}
//                             >
//                               {booking.payment?.paymentStatus}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(
//                                 booking.status,
//                               )}`}
//                             >
//                               {booking.status}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
//                             {new Date(booking.createdAt).toLocaleDateString()}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* Bookings Pagination */}
//                 {bookingsPagination && (
//                   <div className="flex items-center justify-between px-4 py-3 border-t border-border">
//                     <div className="text-sm text-muted-foreground">
//                       Showing{" "}
//                       {(bookingsPagination.currentPage - 1) *
//                         bookingsPagination.itemsPerPage +
//                         1}{" "}
//                       to{" "}
//                       {Math.min(
//                         bookingsPagination.currentPage *
//                           bookingsPagination.itemsPerPage,
//                         bookingsPagination.totalItems,
//                       )}{" "}
//                       of {bookingsPagination.totalItems} bookings
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={bookingsPagination.currentPage === 1}
//                         onClick={() => setBookingPage((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>
//                       <div className="text-sm font-medium px-2">
//                         {bookingsPagination.currentPage} /{" "}
//                         {bookingsPagination.totalPages}
//                       </div>
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={
//                           bookingsPagination.currentPage ===
//                           bookingsPagination.totalPages
//                         }
//                         onClick={() => setBookingPage((prev) => prev + 1)}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Pending Approval Providers */}
//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">
//                     Pending Approval Providers
//                   </h2>
//                   <p className="text-sm text-muted-foreground">
//                     Service providers waiting for approval
//                   </p>
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-muted border-b border-border">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Provider
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Phone
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Email
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         KYC
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Status
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Created
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody className="divide-y divide-border">
//                     {pendingProvidersLoading ? (
//                       [...Array(5)].map((_, idx) => (
//                         <tr key={idx}>
//                           <td colSpan="6" className="px-4 py-4">
//                             <div className="h-10 bg-muted animate-pulse rounded" />
//                           </td>
//                         </tr>
//                       ))
//                     ) : pendingProviders.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="6"
//                           className="px-4 py-8 text-center text-muted-foreground"
//                         >
//                           No pending providers found
//                         </td>
//                       </tr>
//                     ) : (
//                       pendingProviders.map((provider) => (
//                         <tr
//                           key={provider._id}
//                           className="hover:bg-muted/50 transition-colors"
//                         >
//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-3">
//                               {provider.profilePhoto ? (
//                                 <img
//                                   src={provider.profilePhoto}
//                                   alt="provider"
//                                   className="w-10 h-10 rounded-full object-cover"
//                                 />
//                               ) : (
//                                 <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
//                                   <User size={16} />
//                                 </div>
//                               )}
//                               <div className="text-sm font-medium whitespace-nowrap">
//                                 {provider.firstName || "--"}{" "}
//                                 {provider.lastName || ""}
//                               </div>
//                             </div>
//                           </td>

//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {provider.countryCode}
//                             {provider.phoneNumber || "--"}
//                           </td>

//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {provider.email || "--"}
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getProviderStatusColor(
//                                 provider.kyc?.status,
//                               )}`}
//                             >
//                               {provider.kyc?.status || "--"}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getProviderStatusColor(
//                                 provider.status,
//                               )}`}
//                             >
//                               {provider.status}
//                             </span>
//                           </td>

//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {new Date(provider.createdAt).toLocaleDateString()}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* Providers Pagination */}
//                 {providersPagination && (
//                   <div className="flex items-center justify-between px-4 py-3 border-t border-border">
//                     <div className="text-sm text-muted-foreground">
//                       Showing{" "}
//                       {(providersPagination.currentPage - 1) *
//                         providersPagination.itemsPerPage +
//                         1}{" "}
//                       to{" "}
//                       {Math.min(
//                         providersPagination.currentPage *
//                           providersPagination.itemsPerPage,
//                         providersPagination.totalItems,
//                       )}{" "}
//                       of {providersPagination.totalItems} providers
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={providersPagination.currentPage === 1}
//                         onClick={() => setProviderPage((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>
//                       <div className="text-sm font-medium px-2">
//                         {providersPagination.currentPage} /{" "}
//                         {providersPagination.totalPages}
//                       </div>
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={
//                           providersPagination.currentPage ===
//                           providersPagination.totalPages
//                         }
//                         onClick={() => setProviderPage((prev) => prev + 1)}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Recent Support Tickets */}
//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">
//                     Recent Support Tickets
//                   </h2>
//                   <p className="text-sm text-muted-foreground">
//                     Latest customer complaints and support requests
//                   </p>
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-muted border-b border-border">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Ticket #
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Subject
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Customer
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Priority
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Status
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Created
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody className="divide-y divide-border">
//                     {ticketsLoading ? (
//                       [...Array(5)].map((_, idx) => (
//                         <tr key={idx}>
//                           <td colSpan="6" className="px-4 py-4">
//                             <div className="h-10 bg-muted animate-pulse rounded" />
//                           </td>
//                         </tr>
//                       ))
//                     ) : recentTickets.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="6"
//                           className="px-4 py-8 text-center text-muted-foreground"
//                         >
//                           No support tickets found
//                         </td>
//                       </tr>
//                     ) : (
//                       recentTickets.map((ticket) => (
//                         <tr
//                           key={ticket._id}
//                           className="hover:bg-muted/50 transition-colors"
//                         >
//                           {/* Ticket Number */}
//                           <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
//                             {ticket.ticketNumber || "--"}
//                           </td>

//                           {/* Subject */}
//                           <td className="px-4 py-3 text-sm font-medium max-w-xs">
//                             <div className="truncate max-w-[200px]">
//                               {ticket.subject || "--"}
//                             </div>
//                           </td>

//                           {/* Customer */}
//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {ticket.customerId?.firstName || "--"}{" "}
//                             {ticket.customerId?.lastName || "--"}
//                           </td>

//                           {/* Priority */}
//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getTicketPriorityColor(
//                                 ticket.priority,
//                               )}`}
//                             >
//                               {ticket.priority || "--"}
//                             </span>
//                           </td>

//                           {/* Status */}
//                           <td className="px-4 py-3">
//                             <span
//                               className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getTicketStatusColor(
//                                 ticket.status,
//                               )}`}
//                             >
//                               {ticket.status?.replace(/_/g, " ") || "--"}
//                             </span>
//                           </td>

//                           {/* Created */}
//                           <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
//                             {new Date(ticket.createdAt).toLocaleDateString()}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* Tickets Pagination */}
//                 {ticketsPagination && (
//                   <div className="flex items-center justify-between px-4 py-3 border-t border-border">
//                     <div className="text-sm text-muted-foreground">
//                       Showing{" "}
//                       {(ticketsPagination.currentPage - 1) *
//                         ticketsPagination.itemsPerPage +
//                         1}{" "}
//                       to{" "}
//                       {Math.min(
//                         ticketsPagination.currentPage *
//                           ticketsPagination.itemsPerPage,
//                         ticketsPagination.totalItems,
//                       )}{" "}
//                       of {ticketsPagination.totalItems} tickets
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={ticketsPagination.currentPage === 1}
//                         onClick={() => setTicketPage((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>

//                       <div className="text-sm font-medium px-2">
//                         {ticketsPagination.currentPage} /{" "}
//                         {ticketsPagination.totalPages}
//                       </div>

//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={
//                           ticketsPagination.currentPage ===
//                           ticketsPagination.totalPages
//                         }
//                         onClick={() => setTicketPage((prev) => prev + 1)}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Top Sellers By Bookings */}
//             <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
//               <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                 <div>
//                   <h2 className="text-lg font-semibold">
//                     Top Service Providers By Bookings
//                   </h2>

//                   <p className="text-sm text-muted-foreground">
//                     Highest performing sellers based on booking volume
//                   </p>
//                 </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-muted border-b border-border">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Seller
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Email
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Type
//                       </th>

//                       <th className="px-4 py-3 text-left text-xs font-medium uppercase">
//                         Total Bookings
//                       </th>

//                       {/* <th className='px-4 py-3 text-left text-xs font-medium uppercase'>
//               Completed
//             </th>

//             <th className='px-4 py-3 text-left text-xs font-medium uppercase'>
//               Revenue
//             </th> */}
//                     </tr>
//                   </thead>

//                   <tbody className="divide-y divide-border">
//                     {topSellersLoading ? (
//                       [...Array(5)].map((_, idx) => (
//                         <tr key={idx}>
//                           <td colSpan="6" className="px-4 py-4">
//                             <div className="h-10 bg-muted animate-pulse rounded" />
//                           </td>
//                         </tr>
//                       ))
//                     ) : topSellers.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="6"
//                           className="px-4 py-8 text-center text-muted-foreground"
//                         >
//                           No sellers found
//                         </td>
//                       </tr>
//                     ) : (
//                       topSellers.map((seller) => (
//                         <tr
//                           key={seller.sellerId}
//                           className="hover:bg-muted/50 transition-colors"
//                         >
//                           {/* Seller */}
//                           <td className="px-4 py-3">
//                             <div className="flex items-center gap-3">
//                               {seller.profilePhoto ? (
//                                 <img
//                                   src={seller.profilePhoto}
//                                   alt="seller"
//                                   className="w-10 h-10 rounded-full object-cover"
//                                 />
//                               ) : (
//                                 <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
//                                   <User size={16} />
//                                 </div>
//                               )}

//                               <div className="text-sm font-medium whitespace-nowrap">
//                                 {seller.firstName || "--"}{" "}
//                                 {seller.lastName || ""}
//                               </div>
//                             </div>
//                           </td>

//                           {/* Email */}
//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {seller.email || "--"}
//                           </td>

//                           {/* Seller Type */}
//                           <td className="px-4 py-3 text-sm whitespace-nowrap">
//                             {seller.sellerType?.replace(/_/g, " ") || "--"}
//                           </td>

//                           {/* Total Bookings */}
//                           <td className="px-4 py-3">
//                             <span className="text-sm font-semibold">
//                               {seller.totalBookings || 0}
//                             </span>
//                           </td>

//                           {/* Completed */}
//                           {/* <td className='px-4 py-3'>
//                   <span className='text-sm font-semibold text-green-600 dark:text-green-400'>
//                     {seller.completedBookings || 0}
//                   </span>
//                 </td> */}

//                           {/* Revenue */}
//                           {/* <td className='px-4 py-3'>

//                   <div className='flex items-center gap-1 text-sm font-semibold'>

//                     <IndianRupee size={14} />

//                     {(seller.totalRevenue || 0).toLocaleString()}

//                   </div>

//                 </td> */}
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>

//                 {/* Pagination */}
//                 {topSellersPagination && (
//                   <div className="flex items-center justify-between px-4 py-3 border-t border-border">
//                     <div className="text-sm text-muted-foreground">
//                       Showing{" "}
//                       {(topSellersPagination.currentPage - 1) *
//                         topSellersPagination.itemsPerPage +
//                         1}{" "}
//                       to{" "}
//                       {Math.min(
//                         topSellersPagination.currentPage *
//                           topSellersPagination.itemsPerPage,
//                         topSellersPagination.totalItems,
//                       )}{" "}
//                       of {topSellersPagination.totalItems} sellers
//                     </div>

//                     <div className="flex items-center gap-2">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={topSellersPagination.currentPage === 1}
//                         onClick={() => setTopSellerPage((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>

//                       <div className="text-sm font-medium px-2">
//                         {topSellersPagination.currentPage}
//                         {" / "}
//                         {topSellersPagination.totalPages}
//                       </div>

//                       <Button
//                         size="sm"
//                         variant="outline"
//                         disabled={
//                           topSellersPagination.currentPage ===
//                           topSellersPagination.totalPages
//                         }
//                         onClick={() => setTopSellerPage((prev) => prev + 1)}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Layout>
//       </>
//     );
//   };

//   export default ExecutiveDashboard;



import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/ui/Layout';
import Breadcrumb from '../../components/ui/Breadcrumb';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useDashboardStats } from 'features/dashboard/hooks/useDashboardStats';
import { useBookings } from 'features/booking/hooks/useBookings';
import { useSellers } from 'features/seller/hooks/useSellers';
import { useSupportTickets } from 'features/support-ticket/hooks/useSupportTickets';
import { useTopSellersByBookings } from 'features/dashboard/hooks/useTopSellersByBookings';
import { useUserProfile } from "features/auth/hooks/useUserProfile";
import { useMainCategories } from 'features/main-category/hooks/useMainCategories';
import { useCategoryWiseRevenue } from "features/dashboard/hooks/useCategoryWiseRevenue";
import CategoryRevenueChart from "./components/CategoryRevenueChart";
import {
  Eye,
  IndianRupee,
  Package,
  User,
} from 'lucide-react';

// Import dashboard components
import KPICard from './components/KPICard';
import DateRangePicker from './components/DateRangePicker';
import VerticalFilter from './components/VerticalFilter';
import RevenueChart from './components/RevenueChart';
import GeographicHeatmap from './components/GeographicHeatmap';
import OrderFunnel from './components/OrderFunnel';
import AlertsFeed from './components/AlertsFeed';

const ITEMS_PER_PAGE = 5;

const ExecutiveDashboard = () => {
  const [selectedDateRange, setSelectedDateRange] = useState('7d');
  const [selectedVertical, setSelectedVertical] = useState('all');
  const [isRealTimeEnabled, setIsRealTimeEnabled] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const [revenueCategoryId, setRevenueCategoryId] = useState('');

  // Revenue Breakdown table pagination (filtered)
  const [revenueBookingPage, setRevenueBookingPage] = useState(1);
  // Recent Bookings table pagination (unfiltered, independent feed)
  const [recentBookingPage, setRecentBookingPage] = useState(1);

  const [providerPage, setProviderPage] = useState(1);
  const [ticketPage, setTicketPage] = useState(1);
  const [topSellerPage, setTopSellerPage] = useState(1);

  const [revenueSearch, setRevenueSearch] = useState('');
  const [revenueStartDate, setRevenueStartDate] = useState('');
  const [revenueEndDate, setRevenueEndDate] = useState('');

  const [chartStartDate, setChartStartDate] = useState('');
  const [chartEndDate, setChartEndDate] = useState('');

  const { data: profileData } = useUserProfile();
  const user = profileData?.data;

  const {
    data: categoryRevenueResponse,
    isPending: revenueChartLoading,
  } = useCategoryWiseRevenue({
    startDate: chartStartDate || undefined,
    endDate: chartEndDate || undefined,
  });

  const categoryRevenueData = categoryRevenueResponse?.data || [];

  const {
    data: mainCategoriesResponse,
    isLoading: categoriesLoading,
  } = useMainCategories({
    page: 1,
    limit: 100,
    isActive: true,
    sortBy: 'name',
    sortOrder: 'asc',
  });

  const mainCategories = (mainCategoriesResponse?.data || []).filter(
    (category) =>
      !['property-and-real-estate', 'find-jobs'].includes(category.slug)
  );

  const restrictedRoles = [
    "delivery_manager",
    "category_manager",
    "operations_manager",
    "travel_manager",
    // "finance_manager",
  ];

  const showPermissionError = restrictedRoles.includes(user?.role?.name);

  const {
    data: dashboardResponse,
    isPending: dashboardLoading,
    isError,
    error,
  } = useDashboardStats();

  const dashboardStats = dashboardResponse?.data || {};

  // Revenue Breakdown table: filtered bookings query (search/date/category driven)
  const {
    data: revenueBookingResponse,
    isLoading: revenueBookingsLoading,
  } = useBookings({
    page: revenueBookingPage,
    limit: ITEMS_PER_PAGE,
    search: revenueSearch || undefined,
    startDate: revenueStartDate || undefined,
    endDate: revenueEndDate || undefined,
    categoryId: revenueCategoryId || undefined,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  });

  // Recent Bookings table: independent, unfiltered latest-bookings query
  const {
    data: recentBookingResponse,
    isLoading: recentBookingsLoading,
  } = useBookings({
    page: recentBookingPage,
    limit: ITEMS_PER_PAGE,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  });

  // Sellers API shape: { success, data: { sellers: [...], pagination: {...} } }
  const {
    data: pendingProvidersResponse,
    isPending: pendingProvidersLoading,
  } = useSellers({
    page: providerPage,
    limit: ITEMS_PER_PAGE,
    status: 'pending_approval',
    sellerType: 'service_provider',
    sortBy: 'createdAt',
    sortOrder: 'desc',
  });

  const {
    data: ticketsResponse,
    isPending: ticketsLoading,
  } = useSupportTickets({
    page: ticketPage,
    limit: ITEMS_PER_PAGE,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  });

  const {
    data: topSellersResponse,
    isPending: topSellersLoading,
  } = useTopSellersByBookings({
    page: topSellerPage,
    limit: ITEMS_PER_PAGE,
  });

  // Revenue Breakdown table data
  const revenueBookings = revenueBookingResponse?.data || [];
  const revenueBookingsPagination = revenueBookingResponse?.pagination;

  // Recent Bookings table data
  const recentBookings = recentBookingResponse?.data || [];
  const recentBookingsPagination = recentBookingResponse?.pagination;

  const pendingProviders = pendingProvidersResponse?.data?.sellers || [];
  const providersPagination = pendingProvidersResponse?.data?.pagination;

  const recentTickets = ticketsResponse?.data || [];
  const ticketsPagination = ticketsResponse?.pagination;

  const topSellers = topSellersResponse?.data || [];
  const topSellersPagination = topSellersResponse?.pagination;

  const kpiData = [
    {
      title: 'Total Customers',
      value: dashboardStats.totalCustomers || 0,
      icon: 'Users',
      change: '',
      trend: [0.2, 0.4, 0.3, 0.5, 0.6],
    },
    {
      title: 'Active Providers',
      value: dashboardStats.activeProviders || 0,
      icon: 'Users',
      change: '',
      trend: [0.1, 0.3, 0.5, 0.4, 0.7],
    },
    {
      title: 'Pending Provider Approvals',
      value: dashboardStats.pendingApprovalProviders || 0,
      icon: 'Clock',
      change: '',
      trend: [0.4, 0.3, 0.5, 0.2, 0.1],
    },
    {
      title: 'Online Providers',
      value: dashboardStats.onlineProvidersCount || 0,
      icon: 'Activity',
      change: '',
      trend: [0.3, 0.5, 0.7, 0.6, 0.8],
    },
    {
      title: 'Complaints',
      value: dashboardStats.complaintsCount || 0,
      icon: 'AlertTriangle',
      change: '',
      trend: [0.5, 0.4, 0.6, 0.3, 0.2],
    },
    {
      title: 'Revenue',
      value: `₹${(dashboardStats.totalAmount || 0).toLocaleString()}`,
      icon: 'IndianRupee',
      change: '',
      trend: [0.2, 0.4, 0.6, 0.5, 0.8],
    },
  ];

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      confirmed: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      in_progress: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
      completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
      cancelled: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      processing: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
      failed: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getProviderStatusColor = (status) => {
    const colors = {
      pending_approval: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      active: 'bg-green-500/10 text-green-600 dark:text-green-400',
      rejected: 'bg-red-500/10 text-red-600 dark:text-red-400',
      blocked: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getTicketStatusColor = (status) => {
    const colors = {
      open: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      in_progress: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      pending_customer: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
      pending_seller: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
      resolved: 'bg-green-500/10 text-green-600 dark:text-green-400',
      closed: 'bg-gray-500/10 text-gray-600 dark:text-gray-400',
      reopened: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };

    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getTicketPriorityColor = (priority) => {
    const colors = {
      low: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      medium: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      high: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
      urgent: 'bg-red-500/10 text-red-600 dark:text-red-400',
    };

    return colors[priority] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  // Real-time updates simulation
  useEffect(() => {
    if (!isRealTimeEnabled) return;
    const interval = setInterval(() => {
      setLastUpdated(new Date());
    }, 15000);
    return () => clearInterval(interval);
  }, [isRealTimeEnabled]);

  // Only the Revenue Breakdown table's page should reset when its own filters change
  useEffect(() => {
    setRevenueBookingPage(1);
  }, [revenueSearch, revenueStartDate, revenueEndDate, revenueCategoryId]);

  const handleRefresh = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLastUpdated(new Date());
  };

  const handleExport = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
    console.log('Exporting dashboard data...');
  };

  const handleKPIClick = (kpi) => {
    console.log('Drilling down into:', kpi?.title);
  };

  const quickActions = [
    {
      id: 'alerts',
      label: 'Alerts',
      icon: 'Bell',
      onClick: () => console.log('View alerts'),
      variant: 'ghost',
      className: 'relative',
      showLabel: false,
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: 'Settings',
      onClick: () => console.log('Dashboard settings'),
      variant: 'ghost',
      showLabel: false,
    },
  ];

  if (isError) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-xl font-semibold text-destructive">
            {error?.message || 'You do not have permission to perform this action!'}
          </div>
        </div>
      </Layout>
    );
  }

  if (showPermissionError) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-xl font-semibold text-destructive">
            You do not have permission to perform this action!
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <>
      <Helmet>
        <title>Executive Dashboard - Qkly Admin Panel</title>
        <meta
          name="description"
          content="Comprehensive business intelligence dashboard providing real-time analytics and operational monitoring for marketplace administrators"
        />
      </Helmet>
      <Layout>
        <div className="px-6 py-8">
          {/* Header Section */}
          <div className="mb-8">
            <Breadcrumb className="mb-4" />
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div>
                <h1 className="text-3xl font-semibold text-foreground mb-2">
                  Executive Dashboard
                </h1>
                <p className="text-muted-foreground">
                  Comprehensive business intelligence and real-time
                  performance monitoring
                </p>
              </div>
            </div>
          </div>

          {/* KPI Cards Grid */}
          {dashboardLoading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="h-40 rounded-lg border border-border bg-card animate-pulse"
                />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
              {kpiData?.map((kpi, index) => (
                <KPICard
                  key={index}
                  {...kpi}
                  onClick={() => handleKPIClick(kpi)}
                />
              ))}
            </div>
          )}

          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">
                  Category Wise Revenue
                </h2>

                <p className="text-sm text-muted-foreground">
                  Platform commission grouped by category
                </p>
              </div>

              <div className="flex flex-wrap gap-3">
                <input
                  type="date"
                  value={chartStartDate}
                  onChange={(e) => setChartStartDate(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm"
                />

                <input
                  type="date"
                  value={chartEndDate}
                  onChange={(e) => setChartEndDate(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm"
                />

                {(chartStartDate || chartEndDate) && (
                  <Button
                    variant="outline"
                    onClick={() => {
                      setChartStartDate("");
                      setChartEndDate("");
                    }}
                  >
                    Clear
                  </Button>
                )}
              </div>
            </div>

            <div className="p-6">
              <CategoryRevenueChart
                data={categoryRevenueData}
                loading={revenueChartLoading}
              />
            </div>
          </div>

          {/* Revenue breakdown */}
          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">Revenue Breakdown</h2>

                <p className="text-sm text-muted-foreground">
                  Seller revenues
                </p>
              </div>

              <div className="flex flex-wrap gap-3">
                <input
                  type="text"
                  placeholder="Search booking..."
                  value={revenueSearch}
                  onChange={(e) => setRevenueSearch(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm w-60"
                />

                <select
                  value={revenueCategoryId}
                  onChange={(e) => setRevenueCategoryId(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm min-w-[220px]"
                >
                  <option value="">All Categories</option>

                  {mainCategories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name?.english || category.name}
                    </option>
                  ))}
                </select>

                <input
                  type="date"
                  value={revenueStartDate}
                  onChange={(e) => setRevenueStartDate(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm"
                />

                <input
                  type="date"
                  value={revenueEndDate}
                  onChange={(e) => setRevenueEndDate(e.target.value)}
                  className="border rounded-md px-3 py-2 text-sm"
                />

                {(revenueSearch || revenueStartDate || revenueEndDate) && (
                  <Button
                    variant="outline"
                    onClick={() => {
                      setRevenueSearch("");
                      setRevenueStartDate("");
                      setRevenueEndDate("");
                    }}
                  >
                    Clear
                  </Button>
                )}
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Booking
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Seller
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Service/Tour
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Category
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Total Amount
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Platform Fee
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Tax
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Commission
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Payment
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Created
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-border">
                  {revenueBookingsLoading ? (
                    [...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        <td colSpan="7" className="px-4 py-4">
                          <div className="h-10 bg-muted animate-pulse rounded" />
                        </td>
                      </tr>
                    ))
                  ) : revenueBookings.length === 0 ? (
                    <tr>
                      <td
                        colSpan="7"
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No recent bookings found
                      </td>
                    </tr>
                  ) : (
                    revenueBookings.map((booking) => (
                      <tr
                        key={booking._id}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
                          #{booking.bookingNumber}
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                              <User size={14} />
                            </div>
                            <div className="text-sm whitespace-nowrap">
                              {booking.sellerId?.firstName || "--"}{" "}
                              {booking.sellerId?.lastName || "--"}
                            </div>
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Package size={14} />
                            <span className="text-sm whitespace-nowrap">
                              {booking.serviceId?.name ||
                                booking?.tourId?.title ||
                                booking?.sellerId?.restaurantName ||
                                "--"}
                            </span>
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Package size={14} />
                            <span className="text-sm whitespace-nowrap">
                              {booking.serviceId?.categoryId?.name?.english ||
                                booking.tourId?.categoryId?.name?.english ||
                                booking?.foodItems[0]?.categoryId?.name
                                  ?.english ||
                                "--"}
                            </span>
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm font-medium">
                            <IndianRupee size={14} />
                            {booking.pricing?.totalAmount || 0}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm font-medium">
                            <IndianRupee size={14} />
                            {booking.pricing?.platformFee || 0}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm font-medium">
                            <IndianRupee size={14} />
                            {booking.pricing?.taxAmount || 0}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm font-medium">
                            <IndianRupee size={14} />
                            {booking.commission?.commissionAmount || 0}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getPaymentStatusColor(
                              booking.payment?.paymentStatus,
                            )}`}
                          >
                            {booking.payment?.paymentStatus}
                          </span>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(
                              booking.status,
                            )}`}
                          >
                            {booking.status}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
                          {new Date(booking.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Revenue Breakdown Pagination */}
              {revenueBookingsPagination && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-border">
                  <div className="text-sm text-muted-foreground">
                    Showing{" "}
                    {(revenueBookingsPagination.currentPage - 1) *
                      revenueBookingsPagination.itemsPerPage +
                      1}{" "}
                    to{" "}
                    {Math.min(
                      revenueBookingsPagination.currentPage *
                        revenueBookingsPagination.itemsPerPage,
                      revenueBookingsPagination.totalItems,
                    )}{" "}
                    of {revenueBookingsPagination.totalItems} bookings
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={revenueBookingsPagination.currentPage === 1}
                      onClick={() => setRevenueBookingPage((prev) => prev - 1)}
                    >
                      Previous
                    </Button>
                    <div className="text-sm font-medium px-2">
                      {revenueBookingsPagination.currentPage} /{" "}
                      {revenueBookingsPagination.totalPages}
                    </div>
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={
                        revenueBookingsPagination.currentPage ===
                        revenueBookingsPagination.totalPages
                      }
                      onClick={() => setRevenueBookingPage((prev) => prev + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Recent Bookings */}
          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex items-center justify-between px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">Recent Bookings</h2>
                <p className="text-sm text-muted-foreground">
                  Latest booking activities
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Booking
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Customer
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Service
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Amount
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Payment
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Created
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-border">
                  {recentBookingsLoading ? (
                    [...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        <td colSpan="7" className="px-4 py-4">
                          <div className="h-10 bg-muted animate-pulse rounded" />
                        </td>
                      </tr>
                    ))
                  ) : recentBookings.length === 0 ? (
                    <tr>
                      <td
                        colSpan="7"
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No recent bookings found
                      </td>
                    </tr>
                  ) : (
                    recentBookings.map((booking) => (
                      <tr
                        key={booking._id}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
                          #{booking.bookingNumber}
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                              <User size={14} />
                            </div>
                            <div className="text-sm whitespace-nowrap">
                              {booking.customerId?.firstName || "--"}{" "}
                              {booking.customerId?.lastName || "--"}
                            </div>
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Package size={14} />
                            <span className="text-sm whitespace-nowrap">
                              {booking.serviceId?.name ||
                                booking?.tourId?.title ||
                                booking?.sellerId?.restaurantName ||
                                "--"}
                            </span>
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm font-medium">
                            <IndianRupee size={14} />
                            {booking.pricing?.totalAmount || 0}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getPaymentStatusColor(
                              booking.payment?.paymentStatus,
                            )}`}
                          >
                            {booking.payment?.paymentStatus}
                          </span>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(
                              booking.status,
                            )}`}
                          >
                            {booking.status}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
                          {new Date(booking.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Recent Bookings Pagination */}
              {recentBookingsPagination && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-border">
                  <div className="text-sm text-muted-foreground">
                    Showing{" "}
                    {(recentBookingsPagination.currentPage - 1) *
                      recentBookingsPagination.itemsPerPage +
                      1}{" "}
                    to{" "}
                    {Math.min(
                      recentBookingsPagination.currentPage *
                        recentBookingsPagination.itemsPerPage,
                      recentBookingsPagination.totalItems,
                    )}{" "}
                    of {recentBookingsPagination.totalItems} bookings
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={recentBookingsPagination.currentPage === 1}
                      onClick={() => setRecentBookingPage((prev) => prev - 1)}
                    >
                      Previous
                    </Button>
                    <div className="text-sm font-medium px-2">
                      {recentBookingsPagination.currentPage} /{" "}
                      {recentBookingsPagination.totalPages}
                    </div>
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={
                        recentBookingsPagination.currentPage ===
                        recentBookingsPagination.totalPages
                      }
                      onClick={() => setRecentBookingPage((prev) => prev + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Pending Approval Providers */}
          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex items-center justify-between px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">
                  Pending Approval Providers
                </h2>
                <p className="text-sm text-muted-foreground">
                  Service providers waiting for approval
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Provider
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Phone
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Email
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      KYC
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Created
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-border">
                  {pendingProvidersLoading ? (
                    [...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        <td colSpan="6" className="px-4 py-4">
                          <div className="h-10 bg-muted animate-pulse rounded" />
                        </td>
                      </tr>
                    ))
                  ) : pendingProviders.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No pending providers found
                      </td>
                    </tr>
                  ) : (
                    pendingProviders.map((provider) => (
                      <tr
                        key={provider._id}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            {provider.profilePhoto ? (
                              <img
                                src={provider.profilePhoto}
                                alt="provider"
                                className="w-10 h-10 rounded-full object-cover"
                              />
                            ) : (
                              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                                <User size={16} />
                              </div>
                            )}
                            <div className="text-sm font-medium whitespace-nowrap">
                              {provider.firstName || "--"}{" "}
                              {provider.lastName || ""}
                            </div>
                          </div>
                        </td>

                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {provider.countryCode}
                          {provider.phoneNumber || "--"}
                        </td>

                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {provider.email || "--"}
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getProviderStatusColor(
                              provider.kyc?.status,
                            )}`}
                          >
                            {provider.kyc?.status || "--"}
                          </span>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getProviderStatusColor(
                              provider.status,
                            )}`}
                          >
                            {provider.status}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {new Date(provider.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Providers Pagination */}
              {providersPagination && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-border">
                  <div className="text-sm text-muted-foreground">
                    Showing{" "}
                    {(providersPagination.currentPage - 1) *
                      providersPagination.itemsPerPage +
                      1}{" "}
                    to{" "}
                    {Math.min(
                      providersPagination.currentPage *
                        providersPagination.itemsPerPage,
                      providersPagination.totalItems,
                    )}{" "}
                    of {providersPagination.totalItems} providers
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={providersPagination.currentPage === 1}
                      onClick={() => setProviderPage((prev) => prev - 1)}
                    >
                      Previous
                    </Button>
                    <div className="text-sm font-medium px-2">
                      {providersPagination.currentPage} /{" "}
                      {providersPagination.totalPages}
                    </div>
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={
                        providersPagination.currentPage ===
                        providersPagination.totalPages
                      }
                      onClick={() => setProviderPage((prev) => prev + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Recent Support Tickets */}
          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex items-center justify-between px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">
                  Recent Support Tickets
                </h2>
                <p className="text-sm text-muted-foreground">
                  Latest customer complaints and support requests
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Ticket #
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Subject
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Customer
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Priority
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Status
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Created
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-border">
                  {ticketsLoading ? (
                    [...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        <td colSpan="6" className="px-4 py-4">
                          <div className="h-10 bg-muted animate-pulse rounded" />
                        </td>
                      </tr>
                    ))
                  ) : recentTickets.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No support tickets found
                      </td>
                    </tr>
                  ) : (
                    recentTickets.map((ticket) => (
                      <tr
                        key={ticket._id}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        {/* Ticket Number */}
                        <td className="px-4 py-3 text-sm font-medium text-primary whitespace-nowrap">
                          {ticket.ticketNumber || "--"}
                        </td>

                        {/* Subject */}
                        <td className="px-4 py-3 text-sm font-medium max-w-xs">
                          <div className="truncate max-w-[200px]">
                            {ticket.subject || "--"}
                          </div>
                        </td>

                        {/* Customer */}
                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {ticket.customerId?.firstName || "--"}{" "}
                          {ticket.customerId?.lastName || "--"}
                        </td>

                        {/* Priority */}
                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getTicketPriorityColor(
                              ticket.priority,
                            )}`}
                          >
                            {ticket.priority || "--"}
                          </span>
                        </td>

                        {/* Status */}
                        <td className="px-4 py-3">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getTicketStatusColor(
                              ticket.status,
                            )}`}
                          >
                            {ticket.status?.replace(/_/g, " ") || "--"}
                          </span>
                        </td>

                        {/* Created */}
                        <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">
                          {new Date(ticket.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Tickets Pagination */}
              {ticketsPagination && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-border">
                  <div className="text-sm text-muted-foreground">
                    Showing{" "}
                    {(ticketsPagination.currentPage - 1) *
                      ticketsPagination.itemsPerPage +
                      1}{" "}
                    to{" "}
                    {Math.min(
                      ticketsPagination.currentPage *
                        ticketsPagination.itemsPerPage,
                      ticketsPagination.totalItems,
                    )}{" "}
                    of {ticketsPagination.totalItems} tickets
                  </div>

                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={ticketsPagination.currentPage === 1}
                      onClick={() => setTicketPage((prev) => prev - 1)}
                    >
                      Previous
                    </Button>

                    <div className="text-sm font-medium px-2">
                      {ticketsPagination.currentPage} /{" "}
                      {ticketsPagination.totalPages}
                    </div>

                    <Button
                      size="sm"
                      variant="outline"
                      disabled={
                        ticketsPagination.currentPage ===
                        ticketsPagination.totalPages
                      }
                      onClick={() => setTicketPage((prev) => prev + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Top Sellers By Bookings */}
          <div className="bg-card border border-border rounded-lg overflow-hidden mb-8">
            <div className="flex items-center justify-between px-6 py-4 border-b border-border">
              <div>
                <h2 className="text-lg font-semibold">
                  Top Service Providers By Bookings
                </h2>

                <p className="text-sm text-muted-foreground">
                  Highest performing sellers based on booking volume
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Seller
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Email
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Type
                    </th>

                    <th className="px-4 py-3 text-left text-xs font-medium uppercase">
                      Total Bookings
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-border">
                  {topSellersLoading ? (
                    [...Array(5)].map((_, idx) => (
                      <tr key={idx}>
                        <td colSpan="6" className="px-4 py-4">
                          <div className="h-10 bg-muted animate-pulse rounded" />
                        </td>
                      </tr>
                    ))
                  ) : topSellers.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No sellers found
                      </td>
                    </tr>
                  ) : (
                    topSellers.map((seller) => (
                      <tr
                        key={seller.sellerId}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        {/* Seller */}
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            {seller.profilePhoto ? (
                              <img
                                src={seller.profilePhoto}
                                alt="seller"
                                className="w-10 h-10 rounded-full object-cover"
                              />
                            ) : (
                              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                                <User size={16} />
                              </div>
                            )}

                            <div className="text-sm font-medium whitespace-nowrap">
                              {seller.firstName || "--"}{" "}
                              {seller.lastName || ""}
                            </div>
                          </div>
                        </td>

                        {/* Email */}
                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {seller.email || "--"}
                        </td>

                        {/* Seller Type */}
                        <td className="px-4 py-3 text-sm whitespace-nowrap">
                          {seller.sellerType?.replace(/_/g, " ") || "--"}
                        </td>

                        {/* Total Bookings */}
                        <td className="px-4 py-3">
                          <span className="text-sm font-semibold">
                            {seller.totalBookings || 0}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              {topSellersPagination && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-border">
                  <div className="text-sm text-muted-foreground">
                    Showing{" "}
                    {(topSellersPagination.currentPage - 1) *
                      topSellersPagination.itemsPerPage +
                      1}{" "}
                    to{" "}
                    {Math.min(
                      topSellersPagination.currentPage *
                        topSellersPagination.itemsPerPage,
                      topSellersPagination.totalItems,
                    )}{" "}
                    of {topSellersPagination.totalItems} sellers
                  </div>

                  <div className="flex items-center gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={topSellersPagination.currentPage === 1}
                      onClick={() => setTopSellerPage((prev) => prev - 1)}
                    >
                      Previous
                    </Button>

                    <div className="text-sm font-medium px-2">
                      {topSellersPagination.currentPage}
                      {" / "}
                      {topSellersPagination.totalPages}
                    </div>

                    <Button
                      size="sm"
                      variant="outline"
                      disabled={
                        topSellersPagination.currentPage ===
                        topSellersPagination.totalPages
                      }
                      onClick={() => setTopSellerPage((prev) => prev + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ExecutiveDashboard;